import styled from 'styled-components';

export const ButtonPopover = styled.div`
  ${(props) => props.theme.typography.fontBold};
  text-transform: uppercase;
  cursor: pointer;
  position: relative;
  color: ${(props) => props.theme.colors.black};
  @media (max-width: 1150px) {
    display: none;
  }
  &::after {
    content: '';
    position: absolute;
    left: 28px;
    top: 10px;
    height: 80px;
    transition: 0.3s all;
    border-radius: 3px;
    width: 3px;
    transform: rotate(90deg);
    @media (max-width: 1150px) {
      top: 9px;
    }
  }
  &:hover {
    &::after {
      background-color: #585cea;
      box-shadow: 0px 0px 5px 2px #585cea;
    }
  }
`;

interface PopoverProps {
  left?: string;
}

export const PopoverCreateContainer = styled.div<PopoverProps>`
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 0px 0px 10px 10px;
  box-shadow: 0px 10px 10px 1px ${(props) => props.theme.colors.lightGray};
  width: 200px;
  top: 57px;
  cursor: pointer;
  left: ${({ left }) => left || '-40px'};
  display: flex;
  flex-direction: column;
  position: fixed;
  @media (max-width: 1150px) {
    display: none;
  }
`;

export const PopoverLogoutContainer = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  border-radius: 0px 0px 10px 10px;
  box-shadow: 0px 10px 10px 1px ${(props) => props.theme.colors.lightGray};
  width: 200px;
  top: 20px;
  cursor: pointer;
  position: fixed;
  @media (max-width: 1150px) {
    display: none;
  }
`;
